import React from 'react';
import cn from 'classnames';
import { handleImageUrl } from '$/utils/image';
import IconFont from '$/components/IconFont';

import styles from './index.module.scss';

const MATERIAL_CARD_PREVIEW_SIZE = 240;

export interface MaterialCardProps {
  cover: string;
  title: string;
  tags: string[] | null;
  coverWidth: number;
  coverHeight: number;
  selected?: boolean;
  cardRef?: React.Ref<HTMLButtonElement>;
  onClick?: () => void;
  batchMode?: boolean;
  batchSelected?: boolean;
  addLabel?: string;
  onAdd?: () => void;
  addDisabled?: boolean;
}

/**
 * 官方资产单个素材卡片，点击卡片任意区域进入详情。
 */
function MaterialCard({
  cover,
  title,
  tags,
  coverWidth,
  coverHeight,
  selected = false,
  cardRef,
  onClick,
  batchMode = false,
  batchSelected = false,
  addLabel,
  onAdd,
  addDisabled = false,
}: MaterialCardProps): React.ReactElement {
  const coverStyle = { aspectRatio: `${coverWidth} / ${coverHeight}` };

  return (
    <div className={styles.materialCardWrap}>
      <button
        ref={cardRef}
        type="button"
        className={cn(styles.materialCard, { [styles.materialCardSelected]: selected || batchSelected })}
        aria-pressed={batchMode ? batchSelected : selected}
        onClick={onClick}
      >
        <div className={styles.materialCardCover} style={coverStyle}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            className={styles.materialCardImage}
            src={handleImageUrl(cover, { size: MATERIAL_CARD_PREVIEW_SIZE })}
            alt={title}
            crossOrigin="anonymous"
          />
          {batchMode && (
            <span className={styles.materialCardCheckbox} aria-hidden>
              {batchSelected && <IconFont name="checkBoxMark" fontSize={10} color="#fff" />}
            </span>
          )}
        </div>
        <div className={styles.materialCardInfo}>
          <p className={styles.materialCardTitle}>{title}</p>
          <div className={styles.materialCardTags}>
            {tags?.map((tag) => (
              <span key={tag} className={styles.materialCardTag}>{tag}</span>
            ))}
          </div>
        </div>
        {(selected || batchSelected) && <span className={styles.materialCardOutline} />}
      </button>
      {!batchMode && onAdd && (
        <button type="button" className={styles.materialCardAdd} disabled={addDisabled} onClick={onAdd}>
          {addLabel}
        </button>
      )}
    </div>
  );
}

export default MaterialCard;
